import React from "react";

const DoctorDetailsModal = ({ isOpen, onClose, doctorDetails }) => {
  if (!isOpen) return null;

  const fields = doctorDetails
    ? [
        { label: "Full Name", value: doctorDetails.name },
        { label: "Specialization", value: doctorDetails.specialization },
        { label: "Qualification", value: doctorDetails.qualification },
        { label: "Contact", value: doctorDetails.phone_no },
        { label: "Email", value: doctorDetails.email },
        { label: "CNIC", value: doctorDetails.cnic },
        {
          label: "Monthly Pay",
          value: doctorDetails.pay
            ? `PKR ${Number(doctorDetails.pay).toLocaleString()}`
            : "—",
        },
        {
          label: "Commission",
          value: doctorDetails.commission
            ? `${doctorDetails.commission}%`
            : "—",
        },
        {
          label: "Experience",
          value: doctorDetails.experience
            ? `${doctorDetails.experience} Years`
            : "—",
        },
      ]
    : [];

  return (
    <div
      className="fixed inset-0 bg-black/50 flex justify-center items-center z-50 p-2 sm:p-6"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-[70%] max-h-[94vh] flex flex-col overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* ── Header ── */}
        <div className="bg-[#1F2937] px-4 py-3 sm:px-5 sm:py-4 flex items-center justify-between flex-shrink-0">
          <div className="min-w-0 mr-3">
            <p className="text-[10px] font-medium uppercase tracking-widest text-gray-400">
              Doctor Profile
            </p>
            <p className="text-white font-semibold text-sm sm:text-base leading-tight mt-0.5 truncate">
              {doctorDetails?.name || "Doctor"}
            </p>
          </div>
          <button
            onClick={onClose}
            className="flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-full
              bg-white/10 text-gray-300 hover:bg-white/20 hover:text-white
              transition-all duration-200 text-lg font-bold leading-none"
          >
            &times;
          </button>
        </div>

        {/* ── Avatar strip ── */}
        <div className="bg-gray-50 border-b border-gray-100 px-4 py-2.5 sm:px-5 sm:py-3 flex items-center gap-2 sm:gap-3 flex-shrink-0">
          {/* Avatar circle */}
          <div
            className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-gray-800 flex items-center justify-center
            text-white font-bold text-sm flex-shrink-0"
          >
            {doctorDetails?.name?.charAt(0)?.toUpperCase() || "D"}
          </div>

          {/* Specialization + email */}
          <div className="min-w-0 flex-1">
            <p className="text-xs sm:text-sm font-semibold text-gray-800 truncate">
              {doctorDetails?.specialization || "—"}
            </p>
            <p className="text-[11px] text-gray-400 truncate">
              {doctorDetails?.email || "—"}
            </p>
          </div>

          {/* Badge */}
          <span
            className="flex-shrink-0 text-[10px] sm:text-[11px] font-semibold
            px-2 py-0.5 sm:px-2.5 sm:py-1 rounded-full
            bg-blue-50 text-blue-600 border border-blue-100 whitespace-nowrap"
          >
            Doctor
          </span>
        </div>

        {/* ── Scrollable details grid ── */}
        <div className="overflow-y-auto flex-1 px-3 py-3 sm:px-5 sm:py-4">
          {doctorDetails ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3">
              {fields.map(({ label, value }) => (
                <div
                  key={label}
                  className="bg-gray-50 border border-gray-100 rounded-xl px-3 py-2.5 sm:px-4 sm:py-3"
                >
                  <p className="text-[9px] sm:text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-0.5 sm:mb-1">
                    {label}
                  </p>
                  <p className="text-xs sm:text-sm font-medium text-gray-800 break-words leading-snug">
                    {value || "—"}
                  </p>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-10 text-gray-400 text-sm">
              No details available.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DoctorDetailsModal;
